export const meta = {
  title: 'Branding: your name on the door, not ours',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'catalog'],
};

The app your customers scan into is **yours** — your name, your logo, your colours. Our name appears only as a small "part of the network" line. Everything brand-related lives in your branding settings, and every save goes live for customers immediately.

## Your app name

Your customer app is named after the business name you signed up with — it's the title customers see on their home screen when they install your app, and the name on every notification. A shorter version is derived automatically for tight spaces like Android icons.

## Your logo

Upload your logo in the welcome wizard and we do the tedious part: every icon size for Android and iPhone home screens, plus the iOS splash screens, are generated automatically from that one file. Until you upload one, customers see a neutral placeholder.

Skipped the wizard step? A logo re-upload page in the dashboard is coming soon — for now, the wizard upload is the way in.

## Colours and fonts

Your app ships with a clean default palette and system typography. A self-serve colour and font editor is on the way; it isn't in the dashboard yet.

## Operating hours

Open **Hours** from the queue header. This page drives what customers see on their home screen and whether they can book:

- **Weekly hours** — each day has its own open/closed toggle and times. Two shortcuts save typing: **Copy weekday → weekend** and **Apply 9–6 to all**.
- **Today's status** — a live preview pill at the top (_Open now_, _Opens later_, _Closed today_, and so on) shows exactly what customers are seeing, updated as you edit, before you even save.

Customers who open your app while you're closed see it plainly — and booking is blocked until you're open again, so no one joins a queue nobody is washing.

## Holiday overrides

Public holiday? Tap **+ Add a holiday**, pick the date, and mark it closed — or give it special hours. An optional label ("Hari Raya") shows customers why. Overrides beat the weekly schedule on their date only.

## Temporary closure

Renovating, or off for a week? Enable **Closed for a defined window**, set the date range, and write the message customers will see — for example, _"Closed for Hari Raya — back on the 15th."_ While the window is active, it overrides both weekly hours and holiday overrides, and your customer app shows the banner on every screen that matters.

## The public directory switch

At the bottom of the Hours page sits **Show my outlets on the public directory**. Switched on, your active outlets appear on the network's public find page — name, photos, hours, and live wait — and drivers browsing there can jump straight into your app. It's off by default: nobody is listed without flipping it themselves. Turn it off any time to disappear from the directory; your own app and QR keep working exactly as before.

## Changes go live immediately

Every save bumps your branding version, and customer apps pick up the change on their next open — new hours, new logo, new closure banner. No cache-clearing rituals, nothing for customers to reinstall.
